import { WidgetsServicesSplitMain } from '@/widgets/services-split';

export const PagesServicesSplitMain = () => <WidgetsServicesSplitMain />;
